// src/pages/Landing.js
import React, { useEffect } from "react";
import ContactHeader from "../components/ContactHeader";

const LandingPage = () => {
    useEffect(() => {
    // Immediate scroll to top
    window.scrollTo(0, 0);

    // Additional scroll after a tiny delay to ensure everything is rendered
    const timer = setTimeout(() => {
      // Get the form or cart container
      const formContainer = document.querySelector('.delivery-form') ||
        document.querySelector('form') ||
        document.querySelector('.mt-top-cartpage') ||
        document.querySelector('.cart-items-sidebar');

      if (formContainer) {
        formContainer.scrollTop = 0;

        // Also focus on first input if it's the checkout form
        if (window.location.pathname.includes('checkout')) {
          const firstInput = document.querySelector('input, select, textarea');
          if (firstInput) {
            setTimeout(() => firstInput.focus(), 100);
          }
        }
      }
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  return (
    <main className="landing-page mt-4">
      <ContactHeader />
    </main>
  );
};

export default LandingPage;
